import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components'
import { NavItem } from '../LeftNavBar';
import { useCheckBeforeMove } from '../../../shared/hooks/useCheckBeforeMove';

export interface BigMenuFixedProps {
  data: NavItem;
}

const BigMenuFixed: React.FC<BigMenuFixedProps> = ({ data }) => {
  const navigate = useNavigate();
  const { getCurrentPage } = useCheckBeforeMove();

  const checkIsThisPage = () => {
    const { page } = getCurrentPage();
    return page === data.label.toLowerCase();
  }
  const isThisPage = checkIsThisPage();

  const handleMenuClick = () => {
    if (isThisPage) return;
    navigate(data.path);
  }

  return (
    <BigMenuComp $isVisible={data.isVisible} onClick={handleMenuClick}>
      <StyledLink>
        {data.label}
      </StyledLink>
    </BigMenuComp>
  )
}

const BigMenuComp = styled.div<{ $isVisible: boolean }>`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  padding: 0px clamp(12px, 1.2vw, 1.2vw);
  margin-bottom: 6px;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.color_Gray_01};
  opacity: ${({ $isVisible }) => $isVisible ? 1 : 0.3};
  cursor: pointer;
`;

const StyledLink = styled.div`
  cursor: pointer;
  ${({ theme }) => theme.typography.Body_04};
`;

export default BigMenuFixed;
